<failure-wrapper>
  <main class="statement">
    <!-- Bank balances -->
    <bank-header />
    <!-- ! Bank balances -->

    <header class="statement__tabs">
      <cds-tab
        [label]="'Realizados'"
        [checked]="isSelectedTab('done')"
        (click)="setSelectedTab('done')"
      />
      <cds-tab
        [label]="'Todos os registros'"
        [checked]="isSelectedTab('all')"
        (click)="setSelectedTab('all')"
      />
    </header>

    <!--
      A single template, used by both tabs in the `custom` column. Serasa writes
      "Ver ou Editar"; here it is only "Ver" — rule 7 of the card drops document
      editing, and offering "Editar" in the label would promise what the screen
      does not do.
    -->
    <ng-template #financialRecordDetail>
      <span class="statement__detail">Ver</span>
    </ng-template>

    @if (isSelectedTab('done')) {
      <bfm-cash-flow-filters
        [doneEnabled]="false"
        [predictedEnabled]="false"
        [showAppliedFilters]="true"
        [openModal]="true"
      />

      <bfm-paginated-cash-flow
        [headers]="{
          payment_method: 'Método de pagamento',
          paid_at: 'Pago em',
          name: 'Nome',
          coa_name: 'Categoria',
          bank_id: 'Banco',
          value: 'Valor',
          custom: 'Detalhe do registro'
        }"
        [columnList]="cashFlowColumnList"
        [reportType]="'done'"
      />
    }

    @if (isSelectedTab('all')) {
      <financial-list-filters
        (submitSearch)="onSubmitSearch($event)"
        (openFilters)="openFilters()"
      />

      <bfm-paginated-financial-list
        [headers]="{
          status: 'Status',
          coa_name: 'Categoria',
          name: 'Nome',
          bank_id: 'Banco',
          value: 'Valor',
          paid_at: 'Pago em',
          custom: 'Detalhe do registro'
        }"
        [isEditable]="false"
        [columnsList]="financialRecordColumnList"
        [headerClick]="false"
      />
    }
  </main>
</failure-wrapper>
